import React, { FC } from 'react';

export const MetamaskLockedPage: FC = () => <div>[Metamask locked page]</div>;
